"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireWildcard(require("react"));

var _Card = _interopRequireDefault(require("@material-ui/core/Card"));

var _Hidden = _interopRequireDefault(require("@material-ui/core/Hidden"));

var _Button = _interopRequireDefault(require("@material-ui/core/Button"));

var _reactRouterDom = require("react-router-dom");

var _reactRedux = require("react-redux");

var _reactSlick = _interopRequireDefault(require("react-slick"));

var _dialog = _interopRequireDefault(require("../../_common/dialog"));

var _loading = _interopRequireDefault(require("../../_common/loading"));

var _result = _interopRequireDefault(require("../result"));

var _selectors = require("../../../redux/locations/selectors");

var _selectors2 = require("../../../redux/login/selectors");

var _actions = require("../../../redux/events/actions");

var _nicaLocatorCore = require("../../nicaLocatorCore");

require("./index.css");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _iterableToArrayLimit(arr, i) { var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"]; if (_i == null) return; var _arr = []; var _n = true; var _d = false; var _s, _e; try { for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

var SearchResults = function SearchResults(_ref) {
  var setFocusedId = _ref.setFocusedId,
      setFocusedIndex = _ref.setFocusedIndex;

  var _useState = (0, _react.useState)(null),
      _useState2 = _slicedToArray(_useState, 2),
      showClosedDialog = _useState2[0],
      setShowClosedDialog = _useState2[1];

  var _useFilteredLocations = (0, _selectors.useFilteredLocationsSelector)(),
      filteredLocations = _useFilteredLocations.filteredLocations;

  var _useSearchSelector = (0, _selectors.useSearchSelector)(),
      loading = _useSearchSelector.loading;

  var sliderRef = (0, _react.useRef)(null);

  var _useLoginSelector = (0, _selectors2.useLoginSelector)(),
      userIP = _useLoginSelector.userIP;

  var dispatch = (0, _reactRedux.useDispatch)();

  var _useContext = (0, _react.useContext)(_nicaLocatorCore.AppContext),
      customDistanceIcon = _useContext.images.distanceIcon,
      showCovidVerified = _useContext.flags.showCovidVerified;

  var sliderSettings = {
    dots: false,
    arrows: false,
    infinite: false,
    initialSlide: 0,
    speed: 500,
    swipe: true,
    centerMode: true,
    centerPadding: "15px",
    adaptiveHeight: false
  };

  var onLocationClick = function onLocationClick(locationId) {
    return dispatch((0, _actions.trackEvent)(function (tracker) {
      return tracker.trackLocationClick(locationId);
    }));
  };

  var emptyView = /*#__PURE__*/_react.default.createElement("div", {
    className: "locator-results-empty bodyFont"
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: "locator-results-empty-title"
  }, "No results to display."), /*#__PURE__*/_react.default.createElement("div", {
    className: "locator-results-empty-subtitle"
  }, "Try to broaden your search."));

  return /*#__PURE__*/_react.default.createElement("div", {
    className: "locator-results-container"
  }, userIP && (!filteredLocations || loading) ? /*#__PURE__*/_react.default.createElement("div", {
    className: "locator-results-loading"
  }, /*#__PURE__*/_react.default.createElement(_Hidden.default, {
    xsDown: true
  }, /*#__PURE__*/_react.default.createElement(_loading.default, {
    size: 50
  })), /*#__PURE__*/_react.default.createElement(_Hidden.default, {
    smUp: true
  }, /*#__PURE__*/_react.default.createElement(_loading.default, {
    size: 35
  })), /*#__PURE__*/_react.default.createElement("div", {
    className: "flex justify-content-center locator-finding-location bodyFont"
  }, "Finding Current Location...")) : /*#__PURE__*/_react.default.createElement("div", {
    onMouseOut: function onMouseOut() {
      return setFocusedId(-1);
    }
  }, /*#__PURE__*/_react.default.createElement(_Hidden.default, {
    xsDown: true
  }, filteredLocations && filteredLocations.length ? filteredLocations.map(function (result, index) {
    return /*#__PURE__*/_react.default.createElement("div", {
      key: "locator-result-" + index,
      onClick: function onClick() {
        return onLocationClick(result.id);
      }
    }, /*#__PURE__*/_react.default.createElement(_reactRouterDom.Link, {
      to: result.temporarily_closed ? '' : "/".concat(result.id)
    }, /*#__PURE__*/_react.default.createElement(_result.default, {
      result: result,
      onMouseOver: function onMouseOver() {
        return setFocusedId(result.id);
      },
      onClick: function onClick() {
        return result.temporarily_closed ? setShowClosedDialog(index) : null;
      },
      imageSize: 118,
      customDistanceIcon: customDistanceIcon,
      showCovidVerified: showCovidVerified
    })));
  }) : emptyView), /*#__PURE__*/_react.default.createElement(_Hidden.default, {
    smUp: true
  }, filteredLocations && filteredLocations.length ? /*#__PURE__*/_react.default.createElement(_reactSlick.default, _extends({}, sliderSettings, {
    ref: sliderRef,
    afterChange: function afterChange(selectedIndex) {
      return setFocusedIndex(selectedIndex);
    }
  }), filteredLocations.length && filteredLocations.map(function (result, index) {
    return /*#__PURE__*/_react.default.createElement("div", {
      className: "locator-result-mobile-container",
      key: "locator-result-" + index,
      onClick: function onClick() {
        return onLocationClick(result.id);
      }
    }, /*#__PURE__*/_react.default.createElement(_reactRouterDom.Link, {
      to: result.temporarily_closed ? '' : "/".concat(result.id)
    }, /*#__PURE__*/_react.default.createElement(_Card.default, {
      className: "locator-result-card"
    }, /*#__PURE__*/_react.default.createElement(_result.default, {
      result: result,
      onClick: function onClick() {
        return result.temporarily_closed ? setShowClosedDialog(index) : null;
      },
      imageSize: 78,
      customDistanceIcon: customDistanceIcon,
      showCovidVerified: showCovidVerified
    }))));
  })) : emptyView)), /*#__PURE__*/_react.default.createElement(_dialog.default, {
    open: showClosedDialog !== null,
    onClose: function onClose() {
      return setShowClosedDialog(null);
    },
    title: "Location Temporarily Closed",
    actions: /*#__PURE__*/_react.default.createElement(_Button.default, {
      variant: "text",
      color: "primary",
      onClick: function onClick() {
        return setShowClosedDialog(null);
      }
    }, "ok")
  }, showClosedDialog !== null && filteredLocations[showClosedDialog].temporarily_closed_reason ? filteredLocations[showClosedDialog].temporarily_closed_reason : "The Provider did not specify why this location is temporarily closed."));
};

var _default = SearchResults;
exports.default = _default;